import { useEffect, useState } from "react";

import { resolveOssAccessUrl } from "@/components/UploadFile/utils";

/** useOssSignedUrl 入参 */
export interface UseOssSignedUrlOptions {
  /** 业务库 OSS 公网 URL */
  fileUrl?: string;
  /** 是否发起换取请求，默认 true */
  enabled?: boolean;
}

/**
 * 将 OSS 业务 URL 换取短时签名 URL，供 img 等内联预览使用
 */
export const useOssSignedUrl = ({ fileUrl, enabled = true }: UseOssSignedUrlOptions) => {
  /** 短时签名访问 URL */
  const [signedUrl, setSignedUrl] = useState<string>();
  /** 换取签名 URL 请求中 */
  const [loading, setLoading] = useState(false);
  /** 换取失败 */
  const [error, setError] = useState(false);

  useEffect(() => {
    if (!enabled || !fileUrl) {
      setSignedUrl(undefined);
      setLoading(false);
      setError(false);
      return;
    }
    let cancelled = false;
    setLoading(true);
    setError(false);
    // 私有 Bucket 需 inline 签名 URL 才能在页面内预览
    void resolveOssAccessUrl(fileUrl, "inline")
      .then((url) => {
        if (!cancelled) setSignedUrl(url);
      })
      .catch(() => {
        if (!cancelled) {
          setSignedUrl(undefined);
          setError(true);
        }
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, [enabled, fileUrl]);

  return { signedUrl, loading, error };
};
